import { TNullable } from '~/types/Nullable';
import { PayType, ScheduleType } from '../enums';
import { IParsePostingApiResponse, IParsePostingResult } from '../types';

/** Narrows a raw string to a {@link PayType}, falling back to `null` when unknown. */
const toPayType = (value: string | null): TNullable<PayType> =>
  Object.values(PayType).includes(value as PayType) ? (value as PayType) : null;

/** Narrows a raw string to a {@link ScheduleType}, falling back to `null` when unknown. */
const toScheduleType = (value: string | null): TNullable<ScheduleType> =>
  Object.values(ScheduleType).includes(value as ScheduleType) ? (value as ScheduleType) : null;

/**
 * Maps the raw snake_case `POST /postings/parse` response to the camelCase
 * domain entity, narrowing `pay_type` / `schedule_type` to their enums and
 * defaulting a missing `benefits` array to `[]`. Every other null passes
 * through untouched. `expected_days` keep their 0=Sunday … 6=Saturday base.
 */
const toParsePostingResult = (response: IParsePostingApiResponse): IParsePostingResult => {
  const { data, completeness } = response;

  return {
    completeness,
    data: {
      title: data.title,
      professionType: data.profession_type,
      subProfession: data.sub_profession,
      officeSpecialty: data.office_specialty,
      payType: toPayType(data.pay_type),
      minRate: data.min_rate,
      maxRate: data.max_rate,
      benefits: data.benefits ?? [],
      benefitsOther: data.benefits_other,
      scheduleType: toScheduleType(data.schedule_type),
      expectedDays: data.expected_days,
      description: data.description,
    },
  };
};

export const ParsePostingAdapters = {
  toParsePostingResult,
};
